export default __webpack_public_path__ + "static/media/bonna1.385ca483.svg";